import { Card, CardContent, Typography } from "@mui/material";
import { ReactNode } from "react";
import { useStyle } from "./style";

interface IParams {
    title?: string;
    children: ReactNode;
}

export const FlowCard = (props: IParams) => {
    const { title, children } = props;
    const { classes } = useStyle();

    return (
        <Card elevation={2}>
            {title && (
                <CardContent className={classes.header}>
                    <Typography className={classes.title} variant="h2">
                        {title}
                    </Typography>
                </CardContent>
            )}
            <CardContent className={classes.content}>{children}</CardContent>
        </Card>
    );
};
